export const SNOWPACK_PUBLIC_BRANCH = "HEAD";
export const SNOWPACK_PUBLIC_REV = "f5f912a";
export const SNOWPACK_PUBLIC_VERSION = "0.42.0";
export const SNOWPACK_PUBLIC_WHALESPLAINER_URL = "https://create-test.anchor.link";
export const MODE = "production";
export const NODE_ENV = "production";
export const SSR = false;